window.StockCubeCore = window.StockCubeCore || {};

const BANNER_MAP = {
    'top-gainers':       'Top Gainers %',
    'top-losers':        'Top Losers %',
    'top-gainers-sec':   'Top Gainers % - By Sector',
    'top-losers-sec':    'Top Losers % - By Sector',
    'top-vol-sec':       'Top Volume Movers by Sector',
    'top-vol':           'Top Volume Movers',
    'top-dollar-vol-sec':'Top Total Dollar Volume - By Sector Price % Change',
    'top-dollar-vol':    'Top Total Dollar Volume - Price % Change',
    'sip':               'Short Interest Percentage',
    'sip-sec':           'Short Interest Percentage by Sector',
    'watchlist-reports': 'Watchlist Reports',
};

const TIMELINE_HIDDEN_SOURCES = ['sip', 'sip-sec', 'dividend', 'dividend-sec'];

window.StockCubeCore.showError = function (message) {
    if (this.errorDialog && this.errorText) {
        this.errorText.setAttribute('value', message);
        this.errorDialog.setAttribute('visible', true);
        clearTimeout(this.errorTimeout);
        this.errorTimeout = setTimeout(() => this.hideError(), 5000);
        if (__LOG_INFO__) AppLog.info('Error displayed:', message);
    }
};

window.StockCubeCore.hideError = function () {
    if (this.errorDialog) {
        this.errorDialog.setAttribute('visible', false);
        this.errorText.setAttribute('value', '');
    }
};

window.StockCubeCore.emitContextEvent = function () {
    try {
        const detail = {
            interval: String(this.data.interval).toLowerCase(),
            dataSource: String(this.data.dataSource)
        };
        if (__LOG_INFO__) AppLog.info(`CONTEXT EVENT: ${detail.dataSource}, ${detail.interval}`);
        if (this.scene) {
            this.scene.dispatchEvent(new CustomEvent('stock-cube-context', { detail }));
        } else if (this.el && this.el.sceneEl) {
            this.el.sceneEl.dispatchEvent(new CustomEvent('stock-cube-context', { detail }));
        }
    } catch (e) {
        if (__LOG_WARN__) AppLog.warn('Failed to emit stock-cube-context', e);
    }
};

window.StockCubeCore.updateBillboards = function (instant = false) {
    const sceneEl = this.el.sceneEl;
    const camera = sceneEl.camera;
    if (!camera) return;

    const currentCameraPosition = new AFRAME.THREE.Vector3();
    camera.getWorldPosition(currentCameraPosition);

    if (this.data && this.data.dataSource === 'mmap' && this.mmapViewMode === '3d'
            && this.stockBars && this.stockBars.size > 0
            && window.MarketMapSharedRendering && window.MarketMapSharedRendering.updateMmap3DLabelVisibility) {
        window.MarketMapSharedRendering.updateMmap3DLabelVisibility(this, currentCameraPosition);
    }

    const adjustedPosition = new AFRAME.THREE.Vector3().copy(currentCameraPosition);
    adjustedPosition.y -= 0.3;
    const targetQuaternion = new AFRAME.THREE.Quaternion();
    const dummyObj = new AFRAME.THREE.Object3D();

    const billboardEls = Array.from(this.el.querySelectorAll('.billboard'));

    billboardEls.forEach(el => {
        if (!el.object3D || !el.object3D.visible) return;

        if (instant) {
            el.object3D.lookAt(adjustedPosition);
        } else {
            dummyObj.position.copy(el.object3D.position);
            dummyObj.lookAt(adjustedPosition);
            targetQuaternion.copy(dummyObj.quaternion);
            el.object3D.quaternion.slerp(targetQuaternion, 0.1);
        }
    });
};

window.StockCubeCore.recalcLabelPositions = function () {
    if (!this.stockBars) return;
    this.stockBars.forEach((barInfo) => {
        if (!barInfo || !barInfo.primaryLabel) return;
        const newPosition = this.calculateLabelPosition(barInfo, this.rotationData, barInfo.x, -barInfo.z);
        if (newPosition) {
            barInfo.primaryLabel.removeAttribute('animation');
            barInfo.primaryLabel.removeAttribute('animation__rise');
            barInfo.primaryLabel.setAttribute('position',
                `${newPosition.x} ${newPosition.y} ${newPosition.z}`);
        }
    });
};

window.StockCubeCore.setupRotationListener = function () {
    this.rotationUpdateListener = (event) => {
        const rotationData = event.detail;
        this.rotationData = rotationData;

        if (this.stockBars) {
            this.updateBillboards?.();
            window.StockCubeCore.recalcLabelPositions.call(this);
        }

        this.calculateSectorLabelPosition?.(rotationData);
    };

    this.scene.addEventListener('update-rotation', this.rotationUpdateListener);
};

window.StockCubeCore.updateBanner = function () {
    const dataSource = this.data.dataSource;

    if (this.data.banner === this.schema.banner.default || !this.el.getAttribute('stock-cube-visualizer').banner) {
        const newBanner = BANNER_MAP[dataSource] || this.data.banner;
        this.el.setAttribute('stock-cube-visualizer', 'banner', newBanner);
        if (__LOG_INFO__) AppLog.info(`Updated banner to: ${newBanner}`);
    }
};

window.StockCubeCore.updateSelectorVisibility = function (forceHide = false) {
    if (!this.data.selector || !this.data.selector.components['sector-selector']) return;

    const shouldShowSelector = !forceHide && this.isHasSectors;
    const shouldShowTimeline = !forceHide &&
        (this.isHasSectors || !TIMELINE_HIDDEN_SOURCES.includes(this.data.dataSource));

    this.data.selector.setAttribute('visible', shouldShowSelector);
    if (this.data.timelineEntity) {
        this.data.timelineEntity.setAttribute('visible', shouldShowTimeline);
    }

    const watchlistVRSummary = document.querySelector('#watchlist-summary');
    if (watchlistVRSummary) {
        const isWatchlist = !forceHide && this.data.dataSource === 'watchlist-reports' && !!(window.WatchlistApp && window.WatchlistApp.State && window.WatchlistApp.State.summary);
        watchlistVRSummary.setAttribute('visible', isWatchlist);
    }
};
